import React from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'

import { clientRecords } from '@atheneum/api'
import RepeatableAction from './RepeatableAction'
import { Autocomplete } from '@components/Form/Autocomplete'

const InvoicingEntityFields = ({
  form,
  name,
  label,
  parentAccount,
  autoCompleteProps
}) => {
  const invoicingEntities = get(form.values, name)
  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label'>{label}</label>
      <div className='expert-form__input-wrapper'>
        <FieldArray
          name={name}
          render={arrayHelpers => (
            <div className='expert-form__repeatable-input-wrapper'>
              {invoicingEntities.map((invEntity, index) => (
                <div className='expert-form__repeatable-input' key={index}>
                  <Field
                    name={`${name}.${index}`}
                    placeholder=''
                    itemToString={item => (item && item.legalName) || '-'}
                    loadOptions={() =>
                   clientRecords.getInvoicingEntities(parentAccount.id).then(res => {
                        let rows = res.rows
                        rows.unshift({ id: null, legalName: '-' })
                        return rows
                      })
                    }
                    component={Autocomplete}
                    {...autoCompleteProps}
                  />
                  <RepeatableAction
                    fieldValues={invoicingEntities}
                    arrayHelpers={arrayHelpers}
                    index={index}
                    initialObject={{ id: null, legalName: '' }}
                  />
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </div>
  )
}

InvoicingEntityFields.propTypes = {
  form: propTypes.object,
  name: propTypes.string,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]),
  parentAccount: propTypes.object,
  autoCompleteProps: propTypes.object
}

export default observer(InvoicingEntityFields)
